<div class="modal-body">
  <div class="row">
    <div class="col-md-12 col-sm-12 mb-3">
      <h2 class="modal-title">
        {{ "zusatzangabenZuVeraeusserer" | translate }}
        <cap-kompakt-persongb [auskunftsperre]="auskunftsperre" [enableNavigation]="false" [item]="gbPerson"></cap-kompakt-persongb>
      </h2>
    </div>

    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Grundstueck">
        {{ veraeusserer?.eigentumAnteil?.belastetesGrundstueck | kompaktGrundstueck: language }}
      </cap-kopfdatenelement>
    </div>
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Eigentumsform">
        {{ veraeusserer?.eigentumAnteil?.versions[0].eigentumsform | translate }}
      </cap-kopfdatenelement>
    </div>
  </div>

  @if (zusatzangaben.erwerbsart == "EA") {
    <div class="title-divider mt-1 row rubrik-divider mb-1">
      <h3 class="mb-1 mt-0 rubrik-title">{{ "Erwerbsangaben" | translate }}</h3>
    </div>
  }

  @if (zusatzangaben.erwerbsart == "LE") {
    <div class="title-divider mt-1 row rubrik-divider mb-1">
      <h3 class="mb-1 mt-0 rubrik-title">{{ "LetzterEntgeltlicherErwerb" | translate }}</h3>
    </div>
  }

  <div class="row">
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="Rechtsgrund">
        {{ zusatzangaben.rechtsgrundCode?.text | translateName }}
        {{ zusatzangaben.rechtsgrundZusatz }}
      </cap-kopfdatenelement>
      <cap-kopfdatenelement label="Datum">
        {{ zusatzangaben.datum | datum }}
      </cap-kopfdatenelement>
      @if (zusatzangaben.beleg) {
        <cap-kopfdatenelement label="Beleg">
          <cap-kompakt-beleg
            [enableNavigation]="false"
            [item]="zusatzangaben.beleg"
            [openInNewTab]="true"
            [referenzObjectId]="referenzObjectId"
            [referenzObjectType]="referenzObjectArt">
          </cap-kompakt-beleg>
        </cap-kopfdatenelement>
      }
      @if (zusatzangaben.erwerbsart == "EA") {
        <cap-kopfdatenelement label="AusserbuchlicherUebergang">
          {{ zusatzangaben.datumAusserbuchlicherUebergang | datum }}
        </cap-kopfdatenelement>
      }
    </div>
    @if (zusatzangaben.erwerbsart == "EA") {
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Gesamtpreis">
          {{ zusatzangaben.gesamtPreis | betrag }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="DarinEnthalteneZugaben">
          {{ zusatzangaben.darinEnthalteneZugaben | betrag }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="SonderpreisZugaben">
          {{ zusatzangaben.sonderpreisZugabe | betrag }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="Flaeche">
          @if (zusatzangaben.flaecheQuadratmeter) {
            <span> {{ zusatzangaben.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m² </span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="Wertquote">
          @if (zusatzangaben.quote) {
            <span> {{ zusatzangaben.quote.zaehler }}/{{ zusatzangaben.quote.nenner }} </span>
          }
        </cap-kopfdatenelement>
      </div>
    }
  </div>
  @if (zusatzangaben.erwerbsart == "EA") {
    <div class="row">
      <div class="col-md-12">
        <cap-kopfdatenelement bodyClass="col-lg-10" label="Bemerkung" labelClass="col-md-2">
          <div class="align-read-more">
            <cap-read-more [limit]="160" [text]="zusatzangaben.bemerkungen"></cap-read-more>
          </div>
        </cap-kopfdatenelement>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-primary" type="button">
    {{ "Schliessen" | translate }}
  </button>
</div>
